import React, { memo, FC, ReactElement } from 'react';
import { FixedSizeList as VList, areEqual } from 'react-window';
import { Droppable as DndDroppable, Draggable } from 'react-beautiful-dnd';
import classnames from 'classnames';
import { DroppableProps } from '../interface';
import './index.less';

const Droppable: FC<DroppableProps> = (props) => {
  const {
    data,
    virtual = false,
    className,
    style,
    direction = 'vertical',
    droppableId = 'droppable',
    renderItem,
  } = props;

  /** 虚拟列表item */
  // eslint-disable-next-line react/no-unstable-nested-components
  const Row = memo(({ index, style, data }: any) => {
    const item = data[index];
    return (
      <Draggable key={item?.code} draggableId={item?.code} index={index}>
        {(provided) => {
          const ele = renderItem(item, provided) as ReactElement;
          return React.cloneElement(ele, {
            style,
            provided,
            className: classnames(ele.props?.className, { 'fs-drag-drop-item-virtual': virtual }),
          });
        }}
      </Draggable>
    );
  }, areEqual);

  /** 判断是单纯拖拽还是虚拟拖拽 */
  const virtualConfig: any = (() => {
    if (virtual) {
      return {
        mode: 'virtual',
        renderClone: (provided, _, rubric) => {
          return React.cloneElement(renderItem(data[rubric.source.index]) as ReactElement, {
            provided,
          });
        },
        // eslint-disable-next-line react/no-unstable-nested-components
        children: (provided) => {
          return (
            <div className={classnames('fs-drag-drop', `fs-drag-drop-${direction}`, className)} style={style}>
              <VList
                height={200}
                width="100%"
                {...virtual}
                className={classnames('fs-virtual-list', virtual?.className)}
                itemCount={data.length}
                outerRef={provided.innerRef}
                itemData={data}
              >
                {Row}
              </VList>
            </div>
          );
        },
      };
    }
    return {
      // eslint-disable-next-line react/no-unstable-nested-components
      children: (provided) => {
        return (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            className={classnames('fs-drag-drop', `fs-drag-drop-${direction}`, className)}
            style={style}
          >
            {data.map((item, index) => {
              return (
                <Draggable key={item?.code} draggableId={item?.code} index={index}>
                  {(provided) => {
                    return React.cloneElement(renderItem(item) as ReactElement, { provided });
                  }}
                </Draggable>
              );
            })}
            {provided.placeholder}
          </div>
        );
      },
    };
  })();

  return <DndDroppable droppableId={droppableId} {...virtualConfig} direction={direction} />;
};

export default Droppable;
